import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	'pages/analytics/Invoice/AnalyticsInvoicePage'));

export default [{ component, exact: true, path: '/analytics/invoice' }];